import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'
import { AppAction, AppGetter, AppMutation, AppState } from './types'
import { RootState } from '@/store/types'

const namespaced: boolean = true

export const app: Module<AppState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
}

export const types = {
  action:  AppAction,
  mutation: AppMutation,
  getter: AppGetter,
}

export const domain = 'app'

export const vuexModule = {
  [domain]: app,
}
